import { FC, useRef } from "react";
import Modal from "@app/shared/Modals/Modal";
import { MarketNightlyRefreshProviderSet } from "@app/operations/market-nightly-refresh/interfaces";
import { isProviderSetRunning } from "@app/operations/market-nightly-refresh/MarketNightlyRefreshFilters";

interface RunNowPromptProps {
  isRunning: boolean;
  onNotNow: () => void;
  onRunNow: () => void;
  providerSet: MarketNightlyRefreshProviderSet
}

export const RunNowPrompt: FC<RunNowPromptProps> = ({ isRunning, onNotNow, onRunNow, providerSet }) => {
  const hasActedRef = useRef(false);

  const actOnce = (action: () => void): void => {
    if (hasActedRef.current) return;
    hasActedRef.current = true;
    action();
  };

  if (isProviderSetRunning(providerSet)) {
    return (
      <Modal
        closeModal={() => actOnce(onNotNow)}
        content={{
          body: <p>This set is already running and can&apos;t be started again right now.</p>,
          cancelButtonText: "",
          confirmButtonAction: () => actOnce(onNotNow),
          confirmButtonText: "OK",
          title: providerSet.name,
        }}
        hideBodyScroll={true}
        isVisible={true}
      />
    );
  }

  return (
    <Modal
      closeModal={isRunning ? (): void => undefined : () => actOnce(onNotNow)}
      content={{
        body: <p>This set is now scheduled for tonight&apos;s run. Run it now?</p>,
        cancelButtonText: "Not now",
        confirmButtonAction: () => actOnce(onRunNow),
        confirmButtonDisable: isRunning,
        confirmButtonText: "Run now",
        title: providerSet.name,
      }}
      hideBodyScroll={true}
      isVisible={true}
    />
  );
}